import { derivePriceTier } from "@convex/model/stripe";
import type { AnalyticsPlanTier, BillingInterval } from "./events";

/** Stripe's recurring interval → marketing's `billing_interval` value. */
export function toBillingInterval(
  interval: string | null | undefined,
): BillingInterval | null {
  if (interval === "month") return "monthly";
  if (interval === "year") return "yearly";
  return null;
}

/**
 * Splits a subscription lookup key (`standard_month`, `premium_year`, …) into
 * the tier and billing interval analytics report.
 */
export function parseSubscriptionLookupKey(lookupKey: string): {
  plan_tier: AnalyticsPlanTier;
  billing_interval: BillingInterval | null;
} {
  const [, interval] = lookupKey.split("_");
  return {
    plan_tier: derivePriceTier(lookupKey),
    billing_interval: toBillingInterval(interval),
  };
}

/** Stripe amounts are integer cents; analytics reports dollars. */
export function centsToUsd(
  cents: number | null | undefined,
  currency: string | null | undefined,
): number | null {
  if (cents == null || currency?.toLowerCase() !== "usd") return null;
  return cents / 100;
}
